export default {
  SET_MOUNTED_COURSE(state, value) {
    value.mounted_curses.modules.forEach((element) => {
      let videoArray = [];
      let linkArray = [];
      let arrayUnido = [];
      element.lessons[0].resources.forEach((element) => {
        if (element.type === 1 || element.type === 6) {
          videoArray.push(element);
        } else {
          linkArray.push(element);
        }
      });
      arrayUnido = videoArray.concat(linkArray);
      element.lessons[0].resources = arrayUnido;
    });
    state.mounted_course = value;
  },
  SET_LESSON(state, value) {
    state.lesson_selected = value;
  },
};
